var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsYtCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_48_40836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6328 0.160156C7.97135 0.160156 0.132812 7.9987 0.132812 17.6602C0.132812 27.3216 7.97135 35.1602 17.6328 35.1602C27.2943 35.1602 35.1328 27.3216 35.1328 17.6602C35.1328 7.9987 27.2943 0.160156 17.6328 0.160156Z",
    fill: "#D60B1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.1246 20.1904C28.1246 22.8373 27.2204 24.9811 24.5809 24.9811H10.9746C8.32773 24.9811 7.14648 22.8373 7.14648 20.1904V15.13C7.14648 12.4831 8.21836 10.3467 10.8652 10.3467H24.6902C27.3371 10.3467 28.1246 12.4904 28.1246 15.13V20.1904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5312 14.8018L21.2406 17.784L15.5312 20.7663V14.8018Z",
    fill: "url(#paint0_radial_48_40836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.5312 14.8457L20.4969 18.1707L21.2406 17.7842L15.9687 15.028L15.5312 14.8384V14.8457Z",
    fill: "url(#paint1_radial_48_40836)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_48_40836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3896 17.784) scale(2.92396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C2181E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DE2925"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_48_40836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.495834 16.5082) scale(2.34062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C2181E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DE2925"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_40836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.132812 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsYtCircle);
export default __webpack_public_path__ + "static/media/sns_yt_circle.89d867ca80f9dca19ad2008da3207f0b.svg";
export { ForwardRef as ReactComponent };